import { isGivenStorageSupported } from "../LocalStorageUtils/LocalStorageUtils.js";
export const getSessionStorageSupport = isGivenStorageSupported(sessionStorage);
export function writeStorage(key, value) {
  if (!getSessionStorageSupport()) {
    return;
  }

  sessionStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : "".concat(String(value)));
}
export function deleteFromStorage(key) {
  if (!getSessionStorageSupport()) {
    return;
  }

  sessionStorage.removeItem(key);
}
export function getFromStorage(key) {
  if (!getSessionStorageSupport()) {
    return;
  }

  return sessionStorage.getItem(key);
}